/* eslint-disable object-curly-spacing */
// import request from '@/utils/request'
// import ENDPOINT from '@/config/endpoint'

// Fake localStorage implementation for Product Services
const STORAGE_KEYS = {
  PRODUCTS: 'products_fake_db',
  CAPACITIES: 'capacities_fake_db',
  QUESTIONS: 'questions_fake_db',
  PRICES: 'prices_fake_db'
}

function getItem(key) {
  try {
    const data = localStorage.getItem(key)
    return data ? JSON.parse(data) : []
  } catch (e) {
    console.error(`Error reading ${key} from localStorage:`, e)
    return []
  }
}

function setItem(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.error(`Error writing ${key} to localStorage:`, e)
  }
}

function generateId(prefix = 'id') {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`
}

// ----------------------------------------------------
// Products APIs
// ----------------------------------------------------

export function getProducts(params) {
  // return request({
  //   url: ENDPOINT.PRODUCTS,
  //   method: 'get',
  //   params
  // })
  return new Promise((resolve) => {
    let list = getItem(STORAGE_KEYS.PRODUCTS)
    if (params) {
      if (params.organization_id) {
        list = list.filter((p) => String(p.organization_id) === String(params.organization_id))
      }
      if (params.reference_id) {
        list = list.filter((p) => String(p.reference_id) === String(params.reference_id))
      }
      if (params.type) {
        list = list.filter((p) => String(p.type) === String(params.type))
      }
    }
    resolve({ data: list })
  })
}

export function createProduct(data) {
  // return request({
  //   url: ENDPOINT.PRODUCTS,
  //   method: 'post',
  //   data
  // })
  return new Promise((resolve) => {
    const list = getItem(STORAGE_KEYS.PRODUCTS)
    const now = new Date()
    const newProduct = {
      id: generateId('prod'),
      created_at: now.toLocaleDateString('vi-VN') + ' ' + now.toLocaleTimeString('vi-VN'),
      updated_at: now.toLocaleDateString('vi-VN') + ' ' + now.toLocaleTimeString('vi-VN'),
      ...data
    }
    list.unshift(newProduct)
    setItem(STORAGE_KEYS.PRODUCTS, list)
    resolve({ data: newProduct })
  })
}

export function getProductById(id) {
  // return request({
  //   url: `${ENDPOINT.PRODUCTS}/${id}`,
  //   method: 'get'
  // })
  return new Promise((resolve) => {
    const list = getItem(STORAGE_KEYS.PRODUCTS)
    const found = list.find((p) => String(p.id) === String(id) || String(p._id) === String(id))
    resolve({ data: found || null })
  })
}

export function updateProduct(id, data) {
  // return request({
  //   url: `${ENDPOINT.PRODUCTS}/${id}`,
  //   method: 'post',
  //   data
  // })
  return new Promise((resolve) => {
    const list = getItem(STORAGE_KEYS.PRODUCTS)
    const idx = list.findIndex((p) => String(p.id) === String(id) || String(p._id) === String(id))
    const now = new Date()
    if (idx !== -1) {
      list[idx] = {
        ...list[idx],
        ...data,
        updated_at: now.toLocaleDateString('vi-VN') + ' ' + now.toLocaleTimeString('vi-VN')
      }
      setItem(STORAGE_KEYS.PRODUCTS, list)
      resolve({ data: list[idx] })
    } else {
      const newProduct = {
        id: id || generateId('prod'),
        created_at: now.toLocaleDateString('vi-VN') + ' ' + now.toLocaleTimeString('vi-VN'),
        ...data
      }
      list.unshift(newProduct)
      setItem(STORAGE_KEYS.PRODUCTS, list)
      resolve({ data: newProduct })
    }
  })
}

export function deleteProduct(id) {
  // return request({
  //   url: `${ENDPOINT.PRODUCTS}/${id}`,
  //   method: 'delete'
  // })
  return new Promise((resolve) => {
    let list = getItem(STORAGE_KEYS.PRODUCTS)
    list = list.filter((p) => String(p.id) !== String(id) && String(p._id) !== String(id))
    setItem(STORAGE_KEYS.PRODUCTS, list)

    // Clean associated capacities, questions, prices
    let capacities = getItem(STORAGE_KEYS.CAPACITIES)
    capacities = capacities.filter((c) => String(c.product_id) !== String(id))
    setItem(STORAGE_KEYS.CAPACITIES, capacities)

    let questions = getItem(STORAGE_KEYS.QUESTIONS)
    questions = questions.filter((q) => String(q.product_id) !== String(id))
    setItem(STORAGE_KEYS.QUESTIONS, questions)

    let prices = getItem(STORAGE_KEYS.PRICES)
    prices = prices.filter((pr) => String(pr.product_id) !== String(id) && String(pr.applies_to_value) !== String(id))
    setItem(STORAGE_KEYS.PRICES, prices)

    resolve({ data: { message: 'Deleted successfully' } })
  })
}

// ----------------------------------------------------
// Capacity APIs: /products/{{product_id}}/capacity
// ----------------------------------------------------

export function getCapacities(productId, params) {
  // return request({
  //   url: `${ENDPOINT.PRODUCTS}/${productId}/capacity`,
  //   method: 'get',
  //   params
  // })
  return new Promise((resolve) => {
    let list = getItem(STORAGE_KEYS.CAPACITIES)
    list = list.filter((c) => String(c.product_id) === String(productId))
    resolve({ data: list })
  })
}

export function createCapacity(productId, data) {
  // return request({
  //   url: `${ENDPOINT.PRODUCTS}/${productId}/capacity`,
  //   method: 'post',
  //   data
  // })
  return new Promise((resolve) => {
    const list = getItem(STORAGE_KEYS.CAPACITIES)
    const newCapacity = {
      id: generateId('cap'),
      product_id: productId,
      created_at: new Date().toLocaleDateString('vi-VN'),
      ...data
    }
    list.unshift(newCapacity)
    setItem(STORAGE_KEYS.CAPACITIES, list)
    resolve({ data: newCapacity })
  })
}

export function deleteCapacity(productId, capacityId) {
  // return request({
  //   url: `${ENDPOINT.PRODUCTS}/${productId}/capacity`,
  //   method: 'delete',
  //   data: { id: capacityId },
  //   params: { id: capacityId }
  // })
  return new Promise((resolve) => {
    let list = getItem(STORAGE_KEYS.CAPACITIES)
    list = list.filter((c) => String(c.id) !== String(capacityId) && String(c._id) !== String(capacityId))
    setItem(STORAGE_KEYS.CAPACITIES, list)
    resolve({ data: { message: 'Deleted capacity successfully' } })
  })
}

// ----------------------------------------------------
// Questions APIs: /products/{{product_id}}/questions
// ----------------------------------------------------

export function getQuestions(productId, params) {
  return new Promise((resolve) => {
    let list = getItem(STORAGE_KEYS.QUESTIONS)
    list = list.filter((q) =>
      String(q.product_id) === String(productId) ||
      String(q.reference_id) === String(productId)
    )
    resolve({ data: list })
  })
}

export function createQuestion(productId, data) {
  // return request({
  //   url: `${ENDPOINT.PRODUCTS}/${productId}/questions`,
  //   method: 'post',
  //   data
  // })
  return new Promise((resolve) => {
    const list = getItem(STORAGE_KEYS.QUESTIONS)
    const newQuestion = {
      id: generateId('q'),
      product_id: productId,
      created_at: new Date().toLocaleDateString('vi-VN'),
      ...data
    }
    list.unshift(newQuestion)
    setItem(STORAGE_KEYS.QUESTIONS, list)
    resolve({ data: newQuestion })
  })
}

export function deleteQuestion(productId, questionId) {
  // return request({
  //   url: `${ENDPOINT.PRODUCTS}/${productId}/questions`,
  //   method: 'delete',
  //   data: { id: questionId },
  //   params: { id: questionId }
  // })
  return new Promise((resolve) => {
    let list = getItem(STORAGE_KEYS.QUESTIONS)
    list = list.filter((q) => String(q.id) !== String(questionId) && String(q._id) !== String(questionId))
    setItem(STORAGE_KEYS.QUESTIONS, list)
    resolve({ data: { message: 'Deleted question successfully' } })
  })
}

// ----------------------------------------------------
// Prices APIs: /prices
// ----------------------------------------------------

export function getPrices(params) {
  // return request({
  //   url: ENDPOINT.PRICES,
  //   method: 'get',
  //   params
  // })
  return new Promise((resolve) => {
    let list = getItem(STORAGE_KEYS.PRICES)
    if (params) {
      if (params.applies_to_value) {
        list = list.filter((p) =>
          String(p.applies_to_value) === String(params.applies_to_value) ||
          String(p.product_id) === String(params.applies_to_value)
        )
      } else if (params.product_id) {
        list = list.filter((p) =>
          String(p.product_id) === String(params.product_id) ||
          String(p.applies_to_value) === String(params.product_id)
        )
      }
    }
    resolve({ data: list })
  })
}

export function createPrice(data) {
  // return request({
  //   url: ENDPOINT.PRICES,
  //   method: 'post',
  //   data
  // })
  return new Promise((resolve) => {
    const list = getItem(STORAGE_KEYS.PRICES)
    const newPrice = {
      id: generateId('price'),
      created_at: new Date().toLocaleDateString('vi-VN'),
      ...data
    }
    list.unshift(newPrice)
    setItem(STORAGE_KEYS.PRICES, list)
    resolve({ data: newPrice })
  })
}

export function deletePrice(id) {
  // return request({
  //   url: `${ENDPOINT.PRICES}/${id}`,
  //   method: 'delete',
  //   data: { id },
  //   params: { id }
  // })
  return new Promise((resolve) => {
    let list = getItem(STORAGE_KEYS.PRICES)
    list = list.filter((p) => String(p.id) !== String(id) && String(p._id) !== String(id))
    setItem(STORAGE_KEYS.PRICES, list)
    resolve({ data: { message: 'Deleted price successfully' } })
  })
}
